import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Image, Row, Spinner } from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";
import { useLocation, Link } from "react-router-dom";
import { stripHtmlTags } from "utils/helpers";
import { recommendedResourceListing, getResourceDetails } from "api/CategoryService"; // 👈 your API call
import ReactShowMoreText from "react-show-more-text";
import { useParams } from "react-router-dom";
import { Sentry } from "react-activity";
import { useNavigate } from "react-router-dom";
import Loader from "components/Loader";
const ResourcesDetails = () => {
  const location = useLocation();
  const [recommended, setRecommended] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [resource, setResource] = useState(location.state?.resource || null);
  const { id } = useParams();
  console.log('id', id)
  const navigate = useNavigate();
  useEffect(() => {
    const fetchResource = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
  
      try {
        setPageLoading(true)
        const res = await getResourceDetails(id);
        if (res.success && res.body) {
          setResource(res.body);
        } else {
          navigate("/not-found");
        }
      } catch (err) {
        console.error("Failed to fetch resource details from URL:", err);
      } finally {
        setPageLoading(false);
        // setLoading(false);
      }
    };
  
    fetchResource();
  }, [id]); // ✅ only depend on id
  

  useEffect(() => {
    const fetchRecommended = async () => {
      if (!resource?._id) return;
      setLoading(true)
      try {
        const res = await recommendedResourceListing(resource._id);
        if (res.success) {
          setRecommended(res.body || []);
        }
        setLoading(false)
      } catch (err) {
        setLoading(false)
        console.error("Failed to fetch recommended resources:", err);
      }
    };
    fetchRecommended();
  }, [resource]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  if (pageLoading) {
    return (
      <div className="loaderdiv">
        {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
        <Loader />
      </div>
    );
  }

  if (!resource) {
    return (
      <Container>
        <p>Resource not found</p>
      </Container>
    );
  }

  return (

    <>
      <React.Fragment>
        {/* Breadcrumb Section */}
        <BreadcrumbSection
          breadcrumbs={[
            {
              title: "Resources",
              link: "/resources",
            },
            { title: "Webinar Details" },
          ]}
        />

        <Image src={resource.mediaUrl}  alt="" className="img-fluid bigImg resource_img" />
        <section className="software_section py-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="res_details">
                  <h3>{resource.tag}</h3>
                  <h2>{resource.title}</h2>
                  <Card.Text className="seemorepara" as="div">
                    <ReactShowMoreText
                      lines={2}
                      more="See more"
                      less="See less"
                      anchorClass="see-more-link"
                      expanded={false}
                      width={0}
                    >
                      {stripHtmlTags(resource?.description)}
                    </ReactShowMoreText>
                  </Card.Text>
                </div>

                <Button
                  className="border-radius-100 px-5 mt-3"
                  variant="info"
                  onClick={() =>
                    window.open(resource.watchUrl, "_blank", "noopener,noreferrer")
                  }
                >
                  Watch Now
                </Button>

                {recommended.length > 0 && (
                  <>
                    <div className="mb-3 linkHeader mt-5">
                      <h3 className="mb-0">Recommended Posts</h3>
                      {recommended.length > 3 && (
                        <Link to={`/resources-all/${resource.postCategoryId}`} >View All</Link>
                      )}
                    </div>
                    <Row>
                      {recommended.map((card, index) => (
                        <Col md={6} lg={4} sm={12} key={index} className="mb-4">
                          <Card className="h-100 res_Card">
                            <Link
                              to={`/resources-details/${card._id}`}
                            >
                              <Card.Img variant="top" src={card.mediaUrl} />
                            </Link>
                            <Card.Body>
                              <Card.Text className="tag">{card.tag}</Card.Text>
                              <Link
                                to={`/resources-details/${card._id}`}
                              >
                                <Card.Title>{card.title}</Card.Title>
                              </Link>
                              <Card.Text className="para">
                                {stripHtmlTags(card.description)?.slice(0, 100)}...
                              </Card.Text>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    </>
  );
};

export default ResourcesDetails;
